export default "__VITE_ASSET__DeMUUz2d__"